import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const money = (v) => num(v).toFixed(2);
const text = (v) => (v == null ? "" : String(v));

export const generarPdfOrdenCompra = ({ oc, rucEmpresa }) => {
  if (!oc) throw new Error("No se encontró la orden de compra para generar PDF.");

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const fecha = text(oc.created_at?.toDate?.()?.toISOString?.().slice(0, 10) || oc.fecha || "");
  const items = Array.isArray(oc.items) ? oc.items : [];

  doc.setFontSize(16);
  doc.text("ORDEN DE COMPRA", 14, 16);
  doc.setFontSize(10);
  doc.text(`RUC Empresa: ${text(rucEmpresa || oc.ruc_empresa || "-")}`, 14, 23);
  doc.text(`N° OC: ${text(oc.correlativo || oc.id || "-")}`, 14, 28);
  doc.text(`Fecha: ${fecha || "-"}`, 14, 33);
  doc.text(`Estado: ${text(oc.estado || "-")}`, 14, 38);

  doc.text(`Proveedor: ${text(oc.proveedor_razon_social || "-")}`, 14, 46);
  doc.text(`RUC Proveedor: ${text(oc.proveedor_ruc || "-")}`, 14, 51);

  autoTable(doc, {
    startY: 58,
    head: [["#", "Código", "Descripción", "Cant.", "P.Unit", "Importe"]],
    body: items.map((it, i) => [
      i + 1,
      text(it.codigo || "-"),
      text(it.descripcion || "-"),
      num(it.cantidad || 0),
      money(it.precio_ref || 0),
      money(num(it.cantidad || 0) * num(it.precio_ref || 0)),
    ]),
    styles: { fontSize: 9 },
    headStyles: { fillColor: [52, 58, 64] },
  });

  const finalY = doc.lastAutoTable?.finalY || 70;
  const subtotal = num(oc.subtotal);
  const igv = num(oc.igv);
  const total = num(oc.total || subtotal + igv);

  doc.setFontSize(10);
  doc.text(`Moneda: ${text(oc.moneda || "PEN")}`, 14, finalY + 10);
  doc.text(`Subtotal: ${money(subtotal)}`, 140, finalY + 4, { align: "left" });
  doc.text(`IGV: ${money(igv)}`, 140, finalY + 9, { align: "left" });
  doc.setFontSize(11);
  doc.text(`TOTAL: ${money(total)}`, 140, finalY + 15, { align: "left" });

  if (text(oc.observaciones)) {
    doc.setFontSize(10);
    doc.text("Observaciones:", 14, finalY + 22);
    doc.text(text(oc.observaciones), 14, finalY + 27, { maxWidth: 180 });
  }

  const codigo = text(oc.correlativo || oc.id || "OC").replace(/[^A-Za-z0-9-_]/g, "_");
  doc.save(`${codigo}.pdf`);
};

export const generarPdfOrdenVenta = ({ ov, rucEmpresa }) => {
  if (!ov) throw new Error("No se encontró la orden de venta para generar PDF.");

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const lineas = Array.isArray(ov.lineas) ? ov.lineas : [];

  doc.setFontSize(16);
  doc.text("ORDEN DE VENTA", 14, 16);
  doc.setFontSize(10);
  doc.text(`RUC Empresa: ${text(rucEmpresa || ov.ruc_empresa || "-")}`, 14, 23);
  doc.text(`N° OS: ${text(ov.correlativo || ov.id || "-")}`, 14, 28);
  doc.text(`Fecha: ${text(ov.fecha || "-")}`, 14, 33);
  doc.text(`Estado: ${text(ov.estado || "-")}`, 14, 38);

  autoTable(doc, {
    startY: 46,
    head: [["Campo", "Detalle"]],
    body: [
      ["Cliente", text(ov.cliente_razon_social || "-")],
      ["RUC Cliente", text(ov.cliente_ruc || "-")],
      ["Descripción", text(ov.descripcion || "-")],
      ["Moneda", text(ov.moneda || "PEN")],
    ],
    styles: { fontSize: 10 },
    headStyles: { fillColor: [37, 99, 235] },
    columnStyles: { 0: { cellWidth: 45 }, 1: { cellWidth: 135 } },
  });

  const y = doc.lastAutoTable?.finalY || 70;
  if (lineas.length > 0) {
    autoTable(doc, {
      startY: y + 6,
      head: [["#", "Descripción", "Cant.", "P.Unit", "Importe"]],
      body: lineas.map((l, i) => [
        i + 1,
        text(l.descripcion || "-"),
        num(l.cantidad || 0),
        money(l.precio_unitario ?? l.precioUnitario ?? 0),
        money(l.importe ?? (num(l.cantidad) * num(l.precio_unitario ?? l.precioUnitario))),
      ]),
      styles: { fontSize: 9 },
      headStyles: { fillColor: [37, 99, 235] },
    });
  }

  const fy = doc.lastAutoTable?.finalY || y + 6;
  doc.setFontSize(11);
  doc.text(`TOTAL: ${money(ov.total)}`, 140, fy + 10, { align: "left" });

  const codigo = text(ov.correlativo || ov.id || "OS").replace(/[^A-Za-z0-9-_]/g, "_");
  doc.save(`${codigo}.pdf`);
};
